var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25454"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#c3cbd7",
    "data-name": "Rectangle 12140",
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.531 17.475-9.976 11.737h6.723a.573.573 0 0 1 .415.146c.854.978 1.7 1.965 2.541 2.955a.21.21 0 0 0 .089.157H7.289c.168-.189.3-.371.45-.542l10.752-12.594c.461-.542.933-1.123 1.383-1.626a.6.6 0 0 1 .518-.247h4.14z",
    "data-name": "Path 16082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.65 17.49h17.068c-.079.1-.125.179-.179.236q-6.179 7.246-12.357 14.5a.707.707 0 0 1-.639.271h-4.055l9.976-11.726h-6.746a.629.629 0 0 1-.542-.247l-2.337-2.74z",
    "data-name": "Path 16083"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBrand);
export default __webpack_public_path__ + "static/media/Default_Brand.fa6c811b3478b0fb03a8728d1ffa6a3e.svg";
export { ForwardRef as ReactComponent };